import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import billedIcon from '../../../../assets/images/Billed.svg';
import { injectIntl } from 'react-intl';
import { filterBilledLoads, filterRecentPayment, getPONumber, getRecentTruckPayment, isEclipseOpsTruck, setRecentTruckPayment } from "../../../../Utils/Utility";
import { getFormattedDate } from "../../../Common/DateUtils";

function Billed({ intl, ...props }) {
    const billedData = useSelector(state => state.billed);
    const { formatMessage } = intl;

    const getRecentPayment = getRecentTruckPayment();
    if (getRecentPayment.length) {
        let newGetRecentPayment = getRecentPayment.map(el => {
            let fData = filterBilledLoads(el, billedData)
            if (el?.selection === 'Partial Payment') {
                if (fData.length && fData[0]?.total_paid <= 0) return el;
                else return null
            } else if (el?.selection === 'Full Payment') {
                return fData.length ? el : null
            }
        })
        newGetRecentPayment = newGetRecentPayment.filter(x => x)
        setRecentTruckPayment(newGetRecentPayment)
    }

    return (
        <div
            className={
                props.order === 2 ? "tab-pane fade show active" : "tab-pane fade"
            }
            id="pills-Billed"
            role="tabpanel"
            aria-labelledby="pills-Billed-tab"
        >
            {billedData.billedPo?.loads.length > 0 ?
                <div className="custom-tiles-blocks row">
                    {billedData.billedPo.loads.map((item, index) => {
                        let filterPayment = filterRecentPayment(item)
                        return (
                            <div
                                className="col-xs-12 col-xsm-6 col-sm-4 col-xl-4 col-xxl-3"
                                key={item.load_id}
                            >

                                <div className="item position-relative">
                                    <div className="contest_info">
                                        <div className="contest_details">
                                            <div className="d-flex justify-content-between align-items-center contest_date">
                                                <span className="contest_title" title={item.load_control_num}>
                                                    {item.load_control_num}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="description_block">
                                            <div className="d-flex mb-3 align-items-center">
                                                <i
                                                    className="fal fa-map-marker-alt fa-fw"
                                                    style={{ fontSize: "18px" }}
                                                ></i>
                                                <label className="mb-0 eventLocation" title={item.location}>
                                                    {item.location}{" "}
                                                </label>
                                            </div>
                                            <div className="d-flex mb-3 text-danger align-items-center">
                                                <img src={billedIcon} alt="" />
                                                {
                                                    isEclipseOpsTruck(item) ?
                                                        <label className="mb-0 text-danger" title="PO Number" style={{ marginLeft: "12px" }}>
                                                            {getPONumber(item)}</label>
                                                        : <label className="mb-0 text-danger" title="Unloading Completed" style={{ marginLeft: "12px" }}>
                                                            {formatMessage({ id: "app.unloading_completed" })}</label>
                                                }
                                            </div>
                                            <div className="d-flex mb-3 align-items-center">
                                                <i
                                                    className="fal fa-calendar-alt fa-fw"
                                                    style={{ fontSize: "18px" }}
                                                ></i>
                                                <label
                                                    className="mb-0 eventLocation"
                                                    title={item.check_in_time}
                                                >
                                                    {" "}
                                                    {/* {item.check_in_time.substring(8, 10)}-{item.check_in_time.substring(5, 7)}-{item.check_in_time.substring(0, 4)} */}
                                                    {getFormattedDate(item.check_in_time)}
                                                </label>
                                            </div>
                                        </div>
                                        <div className="contest_btn_broup">
                                            {
                                                filterPayment.length ? <Link to={`/billedDetails/${item.load_id}`} className="btn btn-chartreuse min-width processing btn disabled">
                                                    {formatMessage({ id: "app.payment_processing" })}
                                                </Link> : <Link to={`/billedDetails/${item.load_id}`} className="btn btn-chartreuse min-width">
                                                    {formatMessage({ id: "app.more_details" })}
                                                </Link>

                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        );

                    })}
                </div>
                : <div class="empty_block m-auto">
                    <img src={billedIcon} />
                    <label class="text-center mb-3">{formatMessage({ id: "app.no_payment_due_load" })}<Link to={{
                        pathname: `/help`
                    }}><b className='text-orange ml-1'>{formatMessage({ id: "app.click_here" })}</b></Link> {formatMessage({ id: "app.load_help" })}</label>
                </div>}

        </div>
    );
}


export default injectIntl(Billed);
